module.exports = __webpack_public_path__ + "img/arrow_right.9ab331a4.svg";